import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg width="20" height="20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M10 14.167a4.167 4.167 0 100-8.334 4.167 4.167 0 000 8.334z" fill="#54585D" /></svg>);